import React, { useRef } from "react";
import { useButton } from "react-aria";
import styled from "styled-components";

export function CalendarButton(props) {
  const ref = useRef();
  const { buttonProps } = useButton(props, ref);
  return (
    <Button style={{ width: "2.4rem" }} {...buttonProps} ref={ref}>
      {props.children}
    </Button>
  );
}

export function FieldButton(props) {
  const ref = useRef();
  const { buttonProps } = useButton(props, ref);
  return (
    <StyledFieldButton {...buttonProps} ref={ref}>
      {props.children}
    </StyledFieldButton>
  );
}

export const Button = styled.button`
  border: transparent;
  background-color: transparent;
  font-size: inherit;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledFieldButton = styled(Button)`
  padding-inline-start: 0.775rem;
`;
